import request from "@/axios";

// 新增/编辑榜单内容
export const updateListContent = (data) => {
  return request({
    url: "/lebo-card/web/recomendMedia/saveOrUpdate",
    method: "post",
    data,
  });
};

// 查询榜单内容管理列表
export const getListContent = (params) => {
  return request({
    url: '/lebo-card/web/recomendMedia/page',
    method: 'get',
    params
  })
}

// 查询榜单内容管理列表
export const deleteListContent = (params) => {
  return request({
    url: '/lebo-card/web/recomendMedia/delById',
    method: 'get',
    params
  })
}

// 查询榜单内容管理详情
export const getListContentDetail = (params) => {
  return request({
    url: '/lebo-card/web/recomendMedia/findById',
    method: 'get',
    params
  })
}

// 查询榜单内容管理详情
export const getRelevanceApp = () => {
  return request({
    url: '/lebo-card/AppCardThirdPartyApp/getAll',
    method: 'get'
  })
}

/** 查询乐播媒资榜分页数据接口 */
export const getLeboMediaList = (params) => {
  return request({
    url: '/lebo-mediaasset/mediaasset/manage/page',
    method: 'get',
    params
  })
}

/** 校验媒资重复性接口 */
export const checkRepeat = (data) => {
  return request({
    url: '/lebo-card/web/recomendMedia/media-asset/validate',
    method: 'post',
    data: data
  })
}

/** 从媒资库导入媒资 */
export const importMedia = (data) => {
  return request({
    url: '/lebo-card/web/recomendMedia/media-asset/import',
    method: 'post',
    data: data
  })
}

/** 查看日志接口 */
export const getLogList = (params) => {
  return request({
    url: "/lebo-card/web/card/operation-log/page",
    method: "get",
    params: {
      ...params,
      module: 3
    }
  });
}

/** 校验乐播媒资库重复性接口 */
export const checkLBMediaRepeatApi = (data) => {
  return request({
    url: '/lebo-card/web/recomendMedia/media-content/validate',
    method: 'post',
    data: data
  })
}

/** 从乐播媒资库导入媒资 */
export const importLBMediaApi = (data) => {
  return request({
    url: '/lebo-card/web/recomendMedia/media-content/import',
    method: 'post',
    data: data
  })
}
